import { PayloadType } from '../../../Utility/SDK/PayloadType';

export enum EntryPointType {
    CUSTOM = 'customMessage',
    SHARE = 'share',
    BOT = 'botMessage',
    XPROMO = 'xpromo',
}

export type EntryPoint =
    | ICustomEntryPointLegacy
    | ICustomEntryPoint
    | IBotEntryPoint
    | ICrossPromoEntryPoint;

export function isCustomEntryPointLegacy(
    entryPoint: EntryPoint
): entryPoint is ICustomEntryPointLegacy {
    return (
        !!entryPoint &&
        ((entryPoint as ICustomEntryPointLegacy).entryPoint ===
            EntryPointType.CUSTOM ||
            (entryPoint as ICustomEntryPointLegacy).entryPoint ===
                EntryPointType.SHARE) &&
        isCustomEntryPoint((entryPoint as ICustomEntryPointLegacy).payload)
    );
}

export function isCustomEntryPoint(
    entryPoint: EntryPoint
): entryPoint is ICustomEntryPoint {
    return (
        !!entryPoint &&
        !!(entryPoint as ICustomEntryPoint).data &&
        Object.values(PayloadType).includes(
            (entryPoint as ICustomEntryPoint).data
        )
    );
}

export function isBotEntryPoint(
    entryPoint: EntryPoint
): entryPoint is IBotEntryPoint {
    return (
        !!entryPoint &&
        (entryPoint as IBotEntryPoint).entryPoint === EntryPointType.BOT
    );
}

export function isRewardedPayload(
    payload: IBotMessagePayload
): payload is IBotMessagePayload {
    return (
        typeof payload === 'object' &&
        typeof (payload as IBotMessagePayload).gift === 'object' &&
        (typeof payload.gift.id === 'string' ||
            typeof payload.gift.id === 'number')
    );
}

export function isRewardedEntryPointLegacy(
    entryPoint: any
): entryPoint is ICustomEntryPoint {
    return (
        !!entryPoint &&
        !!entryPoint.payload &&
        !!(entryPoint.payload as ICustomEntryPoint).messageId
    );
}

export function isRewardedEntryPoint(
    entryPoint: any
): entryPoint is ICustomEntryPoint {
    return !!entryPoint && !!(entryPoint as ICustomEntryPoint).messageId;
}

export function isCrossPromoEntryPoint(
    entryPoint: EntryPoint
): entryPoint is ICrossPromoEntryPoint {
    return (
        !!entryPoint &&
        (entryPoint as ICrossPromoEntryPoint).entryPoint ===
            EntryPointType.XPROMO &&
        !!(entryPoint as ICrossPromoEntryPoint).gamePayload.originGameId
    );
}

/**
 * Legacy custom bot message format generated by SG-SDK.
 * New messages should be created in the ICustomEntryPoint format.
 */
export interface ICustomEntryPointLegacy {
    entryPoint: EntryPointType.CUSTOM | EntryPointType.SHARE;
    payload: ICustomEntryPoint;
}

export interface ICustomEntryPoint {
    data: PayloadType;
    messageId?: string;
    userId?: string;
    userAvatar?: string;
    userName?: string;
    additions?: any;
}

export interface IBotEntryPoint {
    entryPoint: EntryPointType.BOT;
    gamePayload?: IBotMessagePayload;
    messageCategory?: string;
}

export interface IBotMessagePayload {
    gift: IBotMessageGift;
}

export interface ICrossPromoEntryPoint {
    entryPoint: EntryPointType.XPROMO;
    gamePayload: ICrossPromoPayload;
}

export interface ICrossPromoPayload {
    originGameId: string;
    originPlayerId: string;
    placement?: string;
    promoReward: boolean;
}

export enum GiftType {
    coins = 'coins',
    lives = 'life',
    joker = 'joker',
    TNT = 'tnt',
    Shuffle = 'shuffle',
}

export interface IBotMessageGift {
    giftData: { amount: number; itemId: GiftType }[];
    id: string;
}
